import {useMutation, useQueryClient} from '@tanstack/react-query';

import {updateEventStatus, UpdateEventStatusParams} from '../api';
import {QUERY__EVENT, QUERY__EVENTS} from '../queryKeys';

export const useUpdateEventStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: UpdateEventStatusParams) => updateEventStatus(params),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [QUERY__EVENTS],
      });
      void queryClient.invalidateQueries({
        queryKey: [QUERY__EVENT],
      });
    },
  });
};
